
const AccountOpenPage = ({ attributes }) => {
    const { accountOpen = {} } = attributes;
    const title = accountOpen.title || 'Online BO Open';
    const subtitle = accountOpen.subtitle || '';
    const lead = accountOpen.lead || '';
    const whyTitle = accountOpen.whyTitle || 'Why Use Our Online System?';
    const whyBullets = Array.isArray(accountOpen.whyBullets) ? accountOpen.whyBullets : [];
    const feeLine = accountOpen.feeLine || '';
    const portalCtaText = accountOpen.portalCtaText || '';
    const portalCtaLink = accountOpen.portalCtaLink || '#';

    return (
        <div className="gmf-page-wrapper">
            <section className="gmf-page-hero">
                <div className="gmf-page-hero-inner">
                    {subtitle ? <p className="gmf-page-eyebrow gmf-accent-color">{subtitle}</p> : null}
                    <h1 className="gmf-page-title">{title}</h1>
                    <div className="gmf-divider gmf-divider--center" />
                    {lead ? <p className="gmf-page-subtitle">{lead}</p> : null}
                </div>
            </section>

            <section className="gmf-privacy-sections" style={{ maxWidth: 800, margin: '0 auto 48px', padding: '0 20px' }}>
                <div className="gmf-privacy-section-card">
                    <div className="gmf-privacy-section-header">
                        <h2 className="gmf-privacy-section-title">{whyTitle}</h2>
                    </div>
                    <div className="gmf-privacy-section-content">
                        {whyBullets.length > 0 ? (
                            <ul className="gmf-profile-edu-list">
                                {whyBullets.map((line, i) => (
                                    <li key={i} className="gmf-profile-edu-item">
                                        <span className="gmf-dot" />
                                        <span>{line}</span>
                                    </li>
                                ))}
                            </ul>
                        ) : null}
                        {feeLine ? <p style={{ marginTop: 16 }}>{feeLine}</p> : null}
                        {portalCtaText ? (
                            <p style={{ marginTop: 20 }}>
                                <a
                                    href={portalCtaLink}
                                    className="gmf-btn-primary gmf-btn-sm"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ display: 'inline-flex', textDecoration: 'none' }}
                                >
                                    {portalCtaText}
                                </a>
                            </p>
                        ) : null}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AccountOpenPage;
